module.exports = __webpack_public_path__ + "static/img/image054.fdc63ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news7/image054.png
// module id = DGHq
// module chunks = 1